<script>
	import { PackageVariant } from '../icons';
	import MainLayout from '../layouts/MainLayout.svelte';
</script>

<MainLayout layout_class="not-found" developer_mode="false">
	<div class="empty">
		<div class="empty-icon">
			<PackageVariant size="16em" />
		</div>
		<p class="empty-title h1">Not Found 404.</p>
		<p class="empty-subtitle">ページが見つかりませんでした。</p>
		<div class="empty-action">
			<button class="btn btn-link"><a href="/">ホームへ戻る</a></button>
		</div>
	</div>
</MainLayout>

<style lang="scss">
</style>
